import { Plus } from 'lucide-react';
import { PaymentMethodType, PaymentOption, getPadVerificationLabel } from '../../../helpers/utils/types';
import { getPaymentBadge, getPaymentDisplayName } from '../profileUtils';
import SettingsGroup from './SettingsGroup';

type PaymentMethodsCardProps = {
  paymentMethods: PaymentOption[];
  onAddPaymentMethod: () => void;
  onViewAll: () => void;
};

const PaymentMethodsCard = ({
  paymentMethods,
  onAddPaymentMethod,
  onViewAll,
}: PaymentMethodsCardProps) => (
  <SettingsGroup title='Payment methods'>
    {paymentMethods.length === 0 ? (
      <div className='px-5 py-4 text-[13px] text-[#6B7285]'>No payment methods found.</div>
    ) : (
      paymentMethods.slice(0, 3).map((method) => (
        <div key={method.id} className='flex items-center gap-4 px-5 py-4'>
          <div className='flex h-7 w-10 items-center justify-center rounded-[6px] bg-gradient-to-br from-[#0B1748] to-[#050E2E] text-[9px] font-bold tracking-tight text-white'>
            {getPaymentBadge(method)}
          </div>
          <div className='min-w-0 flex-1'>
            <div className='text-[14px] font-semibold text-main'>
              {getPaymentDisplayName(method)} ••
              {method.cardEndingDigits || method.bankAccountNumber?.slice(-4) || '----'}
            </div>
            <div className='truncate text-[12px] text-[#6B7285]'>
              {method.cardCategoryName || method.bankName || 'Payment method'}
              {method.paymentMethod === PaymentMethodType.PreAuthorizedDebit
                ? ` · ${getPadVerificationLabel(method.isBankAccountLinked)}`
                : ''}
            </div>
          </div>
          {method.isDefault ? (
            <span className='rounded-full bg-[#FEF9E8] px-2 py-1 text-[11px] font-semibold text-[#8A6800]'>
              Default
            </span>
          ) : null}
        </div>
      ))
    )}
    <div className='px-5 py-4'>
      <div className='flex items-center gap-3'>
        <button
          onClick={onAddPaymentMethod}
          className='flex w-full items-center justify-center gap-2 rounded-[10px] border border-[#DEE2EF] bg-white px-4 py-2 text-[13px] font-semibold text-[#0055FF] hover:bg-[#F8F9FC]'
        >
          <Plus size={14} />
          Add payment method
        </button>
        {paymentMethods.length > 3 ? (
          <button
            onClick={onViewAll}
            className='whitespace-nowrap text-[13px] font-semibold text-[#0055FF] hover:underline'
          >
            View all
          </button>
        ) : null}
      </div>
    </div>
  </SettingsGroup>
);

export default PaymentMethodsCard;
